import { ExternalScripts as ExternalScriptsType } from '../store/config/config.reducer';

export const getSailthruScripts = (propertyEndpoint: string, template: string): ExternalScriptsType => {
  if (!propertyEndpoint || !template) return [];

  const customerId = {
    dev: '4928ae82203e0fef1e3123adc265fb19',
    'www.si.com': '855bffce2bac59b73c9fb6e3b423d78f',
    'www.mentalfloss.com': '23b8f2444cc7704f30877c3d6731c7fb',
    fansided: 'c92e7ba97ddecf8d779ded02d904b48b',
    'swimsuit.si.com': '54a08eee2e59823df691703458d210fd',
  };

  // Map propertyEndpoint to customerId key
  let customerKey: string;
  if (
    template === 'PostPageOdesa'
    && propertyEndpoint !== 'www.mentalfloss.com'
  ) {
    customerKey = 'fansided';
  } else if (propertyEndpoint in customerId) {
    customerKey = propertyEndpoint;
  } else {
    customerKey = 'dev'; // default
  }

  const script = `
    // Wait for Sailthru to be available on window before initializing
    (function checkSailthru(attempts = 0) {
      if (typeof window.Sailthru !== 'undefined') {
        Sailthru.init({ customerId: '${customerId[customerKey as keyof typeof customerId]}' });
      } else if (attempts < 3) {
        // Check again after a short delay, limit to 3 attempts
        setTimeout(() => checkSailthru(attempts + 1), 100);
      }
    })();
  `;

  return [
    {
      type: 'URL' as const,
      source: 'https://ak.sail-horizon.com/spm/spm.v1.min.js',
      name: 'sailthru',
      attributes: null,
      loadingType: 'async',
    },
    {
      type: 'code' as const,
      source: script,
      name: 'sailthruInit',
      attributes: null,
      loadingType: 'async',
    },
  ];
};
